import { del, get, post, put } from "./provider";

const ENDPOINTS = {
  login: "/auth/login",
  register: "/auth/register",
  fetchUser: "/auth/user",
  fetchDailyTasks: "/daily/tasks",
  addDailyTasks: "/daily/tasks",
  completeDailyTasks: "/daily/complete",
  deleteAllDailyTasks: "/daily/tasks",
  setCronJobApiKey: "/cron/cronApiKey",
  fetchDials: "/daily/dials",
  addDials: "/daily/dials",
  completeDials: "/daily/call",
  deleteAllDials: "/daily/dials",
  subscribeNotification: "/notification/",
  unsubscribeNotification: (dId) => `/notification/${dId}`,
};

export const loginUserWithEmailAndPassword = (email, password) => {
  return post(ENDPOINTS.login, { email, password });
};

export const registerUser = (userData) => {
  return post(ENDPOINTS.register, userData);
};

export const fetchUserData = () => {
  return get(ENDPOINTS.fetchUser);
};

export const fetchDailyTasks = () => {
  return get(ENDPOINTS.fetchDailyTasks);
};

export const addDailyTask = (taskData) => {
  return post(ENDPOINTS.addDailyTasks, taskData);
};

export const completeDailyTask = (taskIds) => {
  return post(ENDPOINTS.completeDailyTasks, {
    tasks: taskIds,
  });
};
export const deleteAllDailyTasks = (taskIds) => {
  return del(ENDPOINTS.deleteAllDailyTasks, {
    tasks: taskIds,
  });
};

export const setCronJobApiKey = (apiKey) => {
  return put(ENDPOINTS.setCronJobApiKey, { apiKey });
};

export const fetchDials = () => {
  return get(ENDPOINTS.fetchDials);
};

export const addDialContact = (dialData) => {
  return post(ENDPOINTS.addDials, dialData);
};

export const completeDialContact = (dialIds) => {
  return post(ENDPOINTS.completeDials, {
    dials: dialIds,
  });
};

export const deleteAllDialContacts = (dialIds) => {
  return del(ENDPOINTS.deleteAllDials, {
    dials: dialIds,
  });
};

export const fetchDailyWorkouts = () => {
  // return get(ENDPOINTS.fetchDailyTasks);
  return {
    data: [],
  };
};

export const subscribeDeviceToWebPush = async (deviceDetails, subscription) => {
  return post(ENDPOINTS.subscribeNotification, {
    ...deviceDetails,
    subscription,
  });
};

export const unsubscribeDeviceFromWebPush = async (deviceId) => {
  return del(ENDPOINTS.unsubscribeNotification(deviceId));
};
